// extracted by mini-css-extract-plugin
export default {"message":"ConfirmDialog_message__KYm9+","actions":"ConfirmDialog_actions__nPV2L"};